export default {
  customColumns: JSON.parse(window.localStorage.getItem('custom-columns') || '[]')
}